
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Punetopandharpurbushire() {



    const cardData =
    {
        keyword: ' Pune to Pandharpur Bus Hire',
        heading: 'Amruta Travels: Pune to Pandharpur Bus Hire',
        headingDescription: 'Amruta Travels offers Pune to Pandharpur Bus Hire, providing a reliable and devotional travel experience for pilgrims and groups visiting the sacred town of Lord Vitthal. Whether you are planning a spiritual yatra, a family pilgrimage, or a group temple tour, our well-maintained buses ensure a safe and peaceful journey. Choose from 17-seater, 32-seater, and 50-seater options to match your group size. With experienced drivers, on-time service, and affordable rental packages, Amruta Travels makes your Pune to Pandharpur trip comfortable, spiritual, and worry-free. Book your Pandharpur bus today and travel with ease and devotion!',


        top: 'Top Places to Visit in Pandharpur with Amruta Travels',
"topPlaces": [
  {
    "title": "Shri Vitthal Rukmini Mandir",
    "description": "The heart of Pandharpur, this temple is dedicated to Lord Vitthal (a form of Lord Krishna) and his consort Rukmini. It's a major pilgrimage site, especially during the Ashadhi and Kartiki Ekadashi festivals, attracting millions of devotees."
  },
  {
    "title": "Pundalik Temple",
    "description": "Dedicated to Bhakta Pundalik, whose devotion brought Lord Vitthal to Pandharpur. Located on the banks of the Chandrabhaga River, it's believed to be the place where Lord Vitthal stood on a brick, waiting for Pundalik."
  },
  {
    "title": "ISKCON Pandharpur",
    "description": "A serene temple complex established by the International Society for Krishna Consciousness. It offers a peaceful environment for meditation and spiritual learning, with regular kirtans and discourses."
  },
  {
    "title": "Kaikadi Maharaj Math",
    "description": "A unique spiritual center showcasing scenes from Hindu epics through life-size sculptures. It's both educational and devotional, attracting visitors interested in mythology and spirituality."
  },
  {
    "title": "Shri Gopalkrishna Temple",
    "description": "Situated atop Govardhan Hill, this temple resembles a fort and is dedicated to Lord Krishna. It's believed that the temple's kitchen and grinding stone were used by Lord Krishna himself."
  },
  {
    "title": "Vishnupad Temple",
    "description": "An open-hall temple supported by sixteen intricately carved pillars. It houses the sacred footprints of Lord Vishnu, making it a significant spot for devotees."
  },
  {
    "title": "Shri Sant Muktabai Math",
    "description": "Dedicated to the revered saint Muktabai, this math serves as a spiritual retreat. Devotees visit to pay homage and engage in devotional activities."
  },
  {
    "title": "Chandrabhaga River Ghats",
    "description": "The ghats along the Chandrabhaga River are considered sacred. Pilgrims take ritual baths here, especially during festivals, believing it purifies the soul."
  },
  {
    "title": "Bhima River",
    "description": "Also known as Chandrabhaga, the river holds religious significance. Its crescent shape near Pandharpur gives it the name 'Chandrabhaga', and it's integral to various rituals."
  },
  {
    "title": "Tukaram Mandir",
    "description": "A temple dedicated to Sant Tukaram, a prominent Varkari saint. It's a place of devotion and hosts regular bhajans and spiritual gatherings."
  }
],



 "services": [
    {
      "name": "14 17 20 25 Seater Bus for Pune to Pandharpur",
      "description": "Amruta Travels offers 14, 17, 20, and 25-seater buses on rent from Pune to Pandharpur, ideal for small to mid-sized groups visiting the Vitthal Rukmini Temple. Our fleet is equipped with AC/Non-AC options, push-back seats, and experienced drivers to ensure a devotional and comfortable journey."
    },
    {
      "name": "Pune to Tuljapur Tempo Traveller",
      "description": "Travel from Pune to the sacred Tulja Bhavani Temple in Tuljapur with Amruta Travels’ Tempo Traveller rental service. Suitable for family groups or pilgrim tours, our vehicles feature AC, ample luggage space, and comfortable seating for a hassle-free darshan experience."
    },
    {
      "name": "Pune to Tuljapur to Akkalkot Bus On Rent",
      "description": "Plan a pilgrimage circuit from Pune to Tuljapur and Akkalkot with our comfortable bus rental services. This package is perfect for visiting both the Tulja Bhavani and Swami Samarth Mandirs in one trip, offering timely service and well-maintained buses for a smooth travel experience."
    },
    {
      "name": "Bus On Hire in Solapur",
      "description": "Amruta Travels extends its premium bus rental services to Solapur. Whether you're planning a local event, pilgrimage, or intercity travel, our AC and Non-AC buses are available on flexible hire terms to suit all group sizes and travel needs."
    },
    {
      "name": "Best Traveller Bus On Rent in Pune",
      "description": "Looking for reliable and comfortable traveller buses in Pune? Amruta Travels provides a wide range of traveller buses with seating from 14 to 26, perfect for religious tours, family outings, or corporate travel. Expect clean interiors, punctual service, and experienced chauffeurs."
    },
    {
      "name": "Pune to Akkalkot Swami Samarth Mandir Bus On Rent",
      "description": "Visit the holy shrine of Swami Samarth in Akkalkot with Amruta Travels’ bus rentals from Pune. We offer well-equipped buses suitable for group pilgrimages, ensuring safe and serene travel for all devotees headed to the temple."
    },
    {
      "name": "Mini Bus On Rent in Pandharpur",
      "description": "Need transportation within or around Pandharpur? Amruta Travels provides mini bus rentals locally in Pandharpur for darshan tours, temple visits, and short-distance group transport. Choose from AC/Non-AC options with reliable drivers for local travel ease."
    },
    {
      "name": "Pune to Pandharpur Darshan Bus On Rent",
      "description": "Book a bus from Pune to Pandharpur for a comfortable darshan tour. Our fleet is ideal for religious groups or family tours, featuring soft seats, AC climate control, and experienced drivers familiar with devotional routes and schedules."
    },
    {
      "name": "Urbania Bus On Rent in Pune from Pune to Pandharpur",
      "description": "Amruta Travels offers Force Urbania buses for luxury travel from Pune to Pandharpur. Ideal for small, premium groups seeking a smooth and stylish pilgrimage, these AC vehicles feature plush seating, modern interiors, and safe service."
    }
  ],
  "tableData": [
    ["14 17 20 25 Seater Bus for Pune to Pandharpur", "Pune to Tuljapur Tempo Traveller"],
    ["Pune to Tuljapur to Akkalkot Bus On Rent", "Bus On Hire in Solapur"],
    ["Best Traveller Bus On Rent in Pune", "Pune to Akkalkot Swami Samarth Mandir Bus On Rent"],
    ["Mini Bus On Rent in Pandharpur", "Pune to Pandharpur Darshan Bus On Rent"],
    ["Urbania Bus On Rent in Pune from Pune to Pandharpur", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Reliable Travel to Pandharpur",
    "WhyChoosedescription": "Amruta Travels offers Pune to Pandharpur Bus Hire, providing a comfortable and reliable transportation solution for your group. Whether you're traveling for a religious pilgrimage to the famous Vithoba Temple or for any other purpose, our buses ensure a smooth and enjoyable journey. Equipped with spacious seating, air conditioning, and modern amenities, we prioritize comfort and relaxation throughout the journey, allowing you to focus on your destination."
  },
  {
    "WhyChooseheading": "Perfect for Religious Pilgrimages and Group Travel",
    "WhyChoosedescription": "Our Pune to Pandharpur Bus Hire service is the ideal choice for religious groups, family outings, and corporate groups planning a pilgrimage or visit to Pandharpur. Whether it’s a large family group or a community trip, our buses provide ample space and comfort for everyone. We understand the importance of religious journeys and ensure that your trip is both peaceful and enjoyable, offering smooth travel along the route."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers for Safe Travel",
    "WhyChoosedescription": "Safety is paramount, especially when traveling on a long journey like Pune to Pandharpur. Our experienced drivers are well-trained in route navigation and ensure the safety and comfort of all passengers. They are courteous, punctual, and well-versed in the local and regional roads, ensuring you reach your destination on time and safely. With their knowledge and dedication, you can relax and enjoy the journey knowing you are in safe hands."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing for Group Travel",
    "WhyChoosedescription": "We understand the importance of budget planning, and that’s why we offer affordable pricing for Pune to Pandharpur Bus Hire. Our transparent pricing structure ensures there are no hidden charges, allowing you to plan your trip without worry. Whether it's a small group or a large family, we offer competitive rates tailored to your specific travel needs, ensuring you get the best value for your money."
  },
  {
    "WhyChooseheading": "Well-Maintained and Clean Buses for Maximum Comfort",
    "WhyChoosedescription": "Our buses are regularly serviced, maintained, and cleaned to ensure the highest standards of hygiene and comfort. We prioritize cleanliness to offer a safe and pleasant environment for passengers. From air-conditioned interiors to well-maintained seating and amenities, we guarantee a comfortable and enjoyable journey from Pune to Pandharpur, ensuring your trip is as relaxing as possible."
  },
  {
    "WhyChooseheading": "Flexible Pickup and Drop-off Locations in Pune and Pandharpur",
    "WhyChoosedescription": "We offer flexible pick-up and drop-off locations throughout Pune and Pandharpur to make your travel more convenient. Whether you need to be picked up from a school, hotel, office, or any other location in Pune, we can accommodate your specific needs. Upon arrival in Pandharpur, we ensure timely drop-offs at your desired location, making your journey hassle-free and convenient."
  },
  {
    "WhyChooseheading": "Customizable Itinerary to Suit Your Group’s Needs",
    "WhyChoosedescription": "We understand that every trip is unique, and we offer fully customizable itineraries to meet your group’s specific requirements. Whether you want to take breaks along the way, have special stopovers, or change your travel times, we can tailor the itinerary to suit your needs. Our goal is to make your journey from Pune to Pandharpur as comfortable and flexible as possible."
  },
  {
    "WhyChooseheading": "Easy Booking Process and Full Customer Support",
    "WhyChoosedescription": "Booking your Pune to Pandharpur bus hire with Amruta Travels is simple and efficient. You can book online, call our customer service team, or visit our office for personalized assistance. Our dedicated team is available to help with every aspect of your booking, from selecting the right bus to customizing your itinerary, ensuring a smooth and seamless experience from start to finish."
  }
]



























    }

const faqData = [
  {
    question: 'How can I hire a bus for a trip from Pune to Pandharpur?',
    answer: 'Hiring a bus for your Pune to Pandharpur trip with Amruta Travels is easy. You can book online, call our support team, or visit our office. We’ll assist you in selecting the right bus based on your group size and travel needs.',
  },
  {
    question: 'What types of buses are available for the Pune to Pandharpur trip?',
    answer: 'We offer a variety of buses for the Pune to Pandharpur journey, including 32, 35, 45, and 50-seater options. Whether you need a standard or luxury bus, we have a vehicle to fit your travel requirements.',
  },
  {
    question: 'How long does it take to travel from Pune to Pandharpur?',
    answer: 'The travel time from Pune to Pandharpur is approximately 5 to 6 hours, depending on traffic conditions. Our experienced drivers ensure a smooth and timely journey, allowing you to focus on your pilgrimage.',
  },
  {
    question: 'Are the buses comfortable for the Pune to Pandharpur journey?',
    answer: 'Yes, all our buses are well-maintained and equipped with comfortable seating, air conditioning, and spacious interiors. We ensure a comfortable and relaxing ride for your entire journey from Pune to Pandharpur.',
  },
  {
    question: 'Can I book a bus for a one-day trip to Pandharpur?',
    answer: 'Yes, we offer flexible booking options for one-day trips to Pandharpur. We’ll customize the itinerary to include important places of worship and ensure you have enough time to enjoy your trip.',
  },
  {
    question: 'Do you provide both standard and luxury buses for the Pune to Pandharpur trip?',
    answer: 'Yes, we offer both standard and luxury buses. Our luxury buses come with additional amenities such as premium seating, air conditioning, and more, ensuring a high-quality travel experience for your group.',
  },
  {
    question: 'How much does it cost to hire a bus for Pune to Pandharpur?',
    answer: 'The cost depends on the bus size, duration of the trip, and additional services you may require. Please contact us for a customized quote based on your travel details.',
  },
  {
    question: 'Can I request specific pickup and drop-off locations for the trip?',
    answer: 'Yes, we offer flexible pickup and drop-off locations. You can share your preferred locations in Pune and Pandharpur, and we’ll plan the best route for your convenience.',
  },
  {
    question: 'Why choose Amruta Travels for Pune to Pandharpur bus hire?',
    answer: 'Amruta Travels is known for offering reliable, comfortable, and timely bus services for trips from Pune to Pandharpur. Our well-maintained buses, experienced drivers, and focus on customer satisfaction ensure a smooth and enjoyable journey.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Ganesh Sharma',
    role: 'Pilgrimage Group Leader, Pune',
    text: 'We rented a 45-seater bus from Amruta Travels for a pilgrimage trip to Pandharpur. The bus was comfortable and well-maintained, and the driver ensured we had a smooth and safe journey. Highly recommend their service for long-distance trips!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sushma Patil',
    role: 'Traveler, Pune',
    text: 'I booked a 35-seater bus for a family trip to Pandharpur. The bus was clean, the driver was polite and professional, and we had a wonderful experience during the trip. Amruta Travels is my go-to for group trips!',
    rating: 5,
  },
];
















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Pandharpur Bus Hire",
  "image": "https://bushireinpune.com/assets/images/pune-to-pandharpur-bus-hire.jpg",
  "description": "Hire buses from Pune to Pandharpur for darshan trips and temple visits. Options include 14, 15, 17, and 20 seater buses, Tempo Travellers to Tuljapur and Akkalkot, and Urbania vehicles. Book for comfortable group travel to Pandharpur, Tuljapur, Akkalkot, and Solapur region with Amruta Travels.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "5015"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4299",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/pune-to-pandharpur-bus-hire"
  }
};





    return (
        <div>


<Helmet>
  <title>Call: +91 7353109555 | Pune to Pandharpur Bus Hire | Tuljapur & Akkalkot Trip Buses | Amruta Travels</title>
  <meta 
    name="description" 
    content="Book Pune to Pandharpur bus rental services for darshan tours. 14 to 20 seater buses, Urbania, and Tempo Travellers available. Travel to Tuljapur, Akkalkot, and Solapur with Amruta Travels." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/33.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetopandharpurbushire;